import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

import {
  autopilotBodyStyle,
  autopilotCardStyle,
  autopilotDescriptionStyle,
  autopilotEyebrowStyle,
  autopilotHeaderStyle,
  autopilotInsetCardStyle,
  autopilotTitleStyle,
} from "../autopilot/styles";

import "./styles.css";

/**
 * Card "shell" PADRÃO das páginas do Hub (PO1-2723): o `Card.card-everlog-shell`
 * com fundo `--everlog-card-hero-bg` que as referências usam em TODOS os blocos
 * da página (hero, busca, status/resumo e lista de resultados; ver Faturamento
 * "Abertura do faturamento" e Auditoria de Faturas). Cabeçalho opcional no
 * padrão do produto (eyebrow + título + descrição + ação à direita) e corpo com
 * o padding padrão. Tudo por token: acompanha tema claro/escuro e o accent.
 *
 * Use para a lista de resultados ("Documentos encontrados", "Transportadoras",
 * "Negócios cadastrados"...). `MetricCardGroup` é um ShellCard com grid de
 * tiles; `PageHero` e `FilterBand` têm o mesmo shell.
 *
 * Props:
 * - eyebrow, title, description: cabeçalho (todos opcionais; sem nenhum deles
 *   o card renderiza só o corpo).
 * - action: nó no canto superior direito do cabeçalho (contagem, botão...).
 * - className, style: mesclados no Card (style vence; ex.: `marginTop: 0`).
 * - headerStyle, bodyStyle: mesclados no CardHeader / CardBody.
 * - children: conteúdo do corpo.
 */
export default function ShellCard({
  eyebrow,
  title,
  description,
  action,
  className = "",
  style,
  headerStyle,
  bodyStyle,
  children,
}) {
  const hasHeader = Boolean(eyebrow || title || description || action);

  return (
    <Card
      className={`card-everlog-shell hub-shell-card ${className}`.trim()}
      style={{
        ...autopilotCardStyle,
        background: "var(--everlog-card-hero-bg)",
        marginTop: "1.25rem",
        ...style,
      }}
    >
      {hasHeader ? (
        <CardHeader style={{ ...autopilotHeaderStyle, ...headerStyle }}>
          <div className="hub-shell-card__head">
            <div style={{ minWidth: 0 }}>
              {eyebrow ? <div style={autopilotEyebrowStyle}>{eyebrow}</div> : null}
              {title ? <div style={autopilotTitleStyle}>{title}</div> : null}
              {description ? <div style={autopilotDescriptionStyle}>{description}</div> : null}
            </div>
            {action ? <div className="hub-shell-card__action">{action}</div> : null}
          </div>
        </CardHeader>
      ) : null}
      <CardBody style={{ ...autopilotBodyStyle, ...bodyStyle }}>{children}</CardBody>
    </Card>
  );
}

/**
 * Superfície interna PADRÃO para a tabela (e seus estados/paginação) dentro do
 * ShellCard: caixa inset (`autopilotInsetCardStyle`: borda + raio +
 * `--everlog-card-surface-elevated`) sem padding, com overflow escondido para a
 * tabela acompanhar o raio. Dá o contraste entre o card (fundo de hero) e a
 * tabela, como as seções internas da Auditoria de CT-e. `.table`,
 * `.table-responsive` e `.hub-pagination` dentro dela já recebem o ajuste de
 * margem/padding (ShellCard/styles.css).
 */
export function TableSurface({ className = "", style, children }) {
  return (
    <div
      className={`hub-table-surface ${className}`.trim()}
      style={{ ...autopilotInsetCardStyle, padding: 0, overflow: "hidden", ...style }}
    >
      {children}
    </div>
  );
}
